module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/03_Chapter01"
    }
  }, [_vm._v("Equipment – machines")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Your key tools are your sewing machine, overlocker and their presser feet and needles")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Chapter02"
    }
  }, [_vm._v("Tools")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Using the correct tools will make your preparation and sewing more enjoyable")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Chapter03"
    }
  }, [_vm._v("Fabric")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Your choice of fabric will determine the look of your garment")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter04"
    }
  }, [_vm._v("Interfacing")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Use the correct stabiliser for your fabric")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter05"
    }
  }, [_vm._v("Notions")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Buttons, zips, threads, braids and more are indispensable for clothing and accessories")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Measurements")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Correct measurement is the key to a well fitting garment")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Patterns")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Understand your pattern and make small changes to achieve a perfect fit")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preparation – cutting out")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A good beginning is important for a good result")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marking")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Use the correct methods to transfer pattern markings onto the fabric")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pressing")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Well pressed seams are essential for good garment construction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Troubleshooting")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Hints and tips to keep your sewing running smoothly")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sewing techniques")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The most important steps to beautiful garments")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Glossary",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary of terms")])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "side-pt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Sew")]), _vm._v(" (definition)")]), _vm._v(" "), _c('p', {
    staticClass: "side-p"
  }, [_vm._v("To join or to decorate pieces of fabric by means of a thread repeatedly passing through with a needle or similar implement")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container1"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0002-01.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13c59a56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 66
// module chunks = 0